module.exports = __webpack_public_path__ + "img/td.85c6d293.svg";